import React from 'react';
import '../css/App.css';
import '../css/Product.css';
import ls from 'local-storage'
import {withRouter} from "react-router";
import urls from "../configs/urls";
class ItemImage extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            image: props.image,
            type: props.type,
            link: props.link,
            stores_id: props.stores_id,
            products_id:props.products_id

        };
        this.handleOnclick = this.handleOnclick.bind(this);
    }
    componentWillReceiveProps(props) {
        this.setState(
            {
                image: props.image,
                type: props.type,
                link: props.link,
                stores_id: props.stores_id,
                products_id:props.products_id
            });

    }
    render() {
        return (
            <div className={'itemImageDiv'}>
                <img className={'itemImage'} onClick={this.handleOnclick} src={urls.SiteUrl+this.state.image}/>
            </div>
        )
    }


    handleOnclick() {
        switch (this.state.type){
            case 'LINK':
                window.open(this.state.link);
                break;
            case 'PRODUCT':
                if(this.state.products_id.charAt(0) == '['){
                    ls.set('products_id',this.state.products_id);
                    this.props.history.push("/products");
                }
                else{
                    ls.set("product_id",this.state.products_id);
                    this.props.history.push("/product");
                }
                break;

            case 'STORE':
                if(this.state.stores_id.charAt(0) == '['){
                    ls.set('stores_id',this.state.stores_id);
                    this.props.history.push("/stores_show");
                }
                else{
                    ls.set("store_id",this.state.stores_id);
                    this.props.history.push({
                        pathname: '/store',
                        state: {id:this.state.stores_id}
                    });
                }

        }

    }

}

export default withRouter(ItemImage);
